<template>
  <div id="card-tasks" class="card-tasks">
    <AppSeparator class="card-window__separator" />
    <SectionHeading icon="far fa-check-double">
      {{ $t('card_modal.sections.tasks') }}
    </SectionHeading>
    <div class="card-tasks__descripton">
      {{ $t('card_modal.sections.tasks_description') }}
    </div>
    <!-- checklist -->
    <Checklists :listing="tasks" />
  </div>
</template>

<script>
// Utitlities
import { authComputed } from 'Store/helpers'
// Components
import Checklists from 'Modules/Checklists'
import AppSeparator from 'Ui/AppSeparator'
import SectionHeading from 'Components/SectionHeading'

export default {
  name: 'CardModalTasks',

  components: {
    Checklists,
    AppSeparator,
    SectionHeading,
  },

  props: {
    tasks: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...authComputed,
    isEmployee() {
      return this.userType === 'EMPLOYEE'
    },
  },
}
</script>

<style scoped>
.card-tasks__descripton {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--c-secondary);
  padding: 0 40px 0 30px;
  margin-top: 15px;
}
</style>
